var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14.063,
    viewBox: "0 0 20 14.063",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#EEB000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.726,78.921a.781.781,0,0,0-.849-.108L14.6,80.894,10.59,76.269a.781.781,0,0,0-1.18,0L5.4,80.894,1.123,78.813a.781.781,0,0,0-1.089.93L3,89.509a.781.781,0,0,0,.747.554h12.5A.781.781,0,0,0,17,89.509l2.969-9.766A.781.781,0,0,0,19.726,78.921ZM15.671,88.5H4.329L2.049,81l3.2,1.56a.781.781,0,0,0,.932-.191L10,77.974l3.814,4.4a.781.781,0,0,0,.932.191L17.95,81Z",
    transform: "translate(0 -76)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.54b40f91.svg";
export { ForwardRef as ReactComponent };